import { render, staticRenderFns } from "./DoughnutGoalCard.vue?vue&type=template&id=571b760a&scoped=true&"
import script from "./DoughnutGoalCard.vue?vue&type=script&lang=js&"
export * from "./DoughnutGoalCard.vue?vue&type=script&lang=js&"
import style0 from "./DoughnutGoalCard.vue?vue&type=style&index=0&id=571b760a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571b760a",
  null
  
)

export default component.exports